<template>
  <div class="my-5">
    <div class="d-flex justify-content-between align-items-baseline mb-2">
      <p class="mb-0 text-dark fs-18">Historial de actividad</p>
      <small class="text-muted" v-if="!loading">{{ events.length }} registros</small>
    </div>

    <b-table
      :items="events"
      :fields="fields"
      :busy="loading"
      small
      hover
      responsive
      show-empty
      empty-text="Sin actividad registrada"
      class="fs-14"
    >
      <template #table-busy>
        <div class="text-center text-muted py-3">
          <b-spinner small class="mr-2 text-info" />Cargando...
        </div>
      </template>

      <template #cell(created_at)="{ value }">
        {{ value | formatDateTime }}
      </template>

      <template #cell(user)="{ value }">
        {{ value | concatName2 | titleize }}
      </template>

      <template #cell(action)="{ item }">
        <b-badge :variant="badgeVariant(item.action)" class="fs-13" style="width: 105px;">{{ actionMap[item.action] }}</b-badge>
      </template>

      <template #cell(description)="{ value }">
        <span :class="value ? '' : 'text-muted'">{{ value || '—' }}</span>
      </template>

      <template #cell(document)="{ item }">
        <b-button
          v-if="item.document"
          v-b-tooltip.hover
          type="button"
          size="sm"
          class="d-flex align-items-center py-0 fs-14 px-2"
          :title="item.document.name"
          :disabled="downloadingId === item.id"
          variant="outline-danger"
          @click="downloadDocument(item)"
        >
          <b-spinner v-if="downloadingId === item.id" small />
          <font-awesome-icon v-else :icon="['far', 'file-pdf']" />
          <span class="ml-2">Submital</span>
        </b-button>
      </template>
    </b-table>
  </div>
</template>

<script>

const BADGE_VARIANTS = {
  locked: 'danger',
  unlocked: 'info'
}

export default {
  name: 'AuditEventTable',
  props: {
    url: { type: String, required: true }
  },
  data () {
    return {
      events: [],
      loading: false,
      fields: [
        { key: 'created_at', label: 'Fecha', thStyle: { width: '170px' } },
        { key: 'user', label: 'Usuario', thStyle: { width: '170px' } },
        { key: 'action', label: 'Acción', thStyle: { width: '140px' } },
        { key: 'description',  label: 'Descripción' },
        { key: 'document', label: '', thStyle: { width: '60px' } }
      ],
      actionMap: {
        locked: 'Bloqueado',
        unlocked: 'Desbloqueado'
      },
      downloadingId: null
    }
  },
  mounted () {
    this.fetchEvents()
  },
  methods: {
    fetchEvents () {
      this.loading = true
      this.$http.get(this.url)
        .then(res => {
          this.events = res.data
        })
        .catch(() => { this.events = [] })
        .finally(() => { this.loading = false })
    },
    badgeVariant (action) {
      return BADGE_VARIANTS[action] || 'light'
    },
    formatDate (value) {
      if (!value) return ''
      return new Date(value).toLocaleString('es-CR', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit'
      })
    },
    downloadDocument (auditEvent) {
      if (this.downloadingId) return

      this.downloadingId = auditEvent.id
      this.$http.get(`/api/production/audit_events/${auditEvent.id}/documents/${auditEvent.document.id}/download`)
        .then(res => {
          const link = document.createElement('a')
          link.href = res.data
          link.download = auditEvent.document.name
          link.click()
        })
        .catch(e => console.log(e))
        .finally(() => { this.downloadingId = null })
    }
  }
}
</script>
